




















































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { bus } from "../../main";
import * as user from "../../_store/user.module";

@Component
export default class EditTirFormativo extends Vue {
    @Prop() info!: any;
    private dataInizio: string;
    private dataFine: string;
    private dataInizioTemp: string;
    private dataFineTemp: string;
    private dataInizioRules: [boolean | string];
    private dataFineRules: [boolean | string];
    private dataInizioMenu: boolean;
    private dataFineMenu: boolean;
    private isAnnullato: boolean;

    constructor() {
        super();
        this.dataInizioMenu = false;
        this.dataFineMenu = false;
        this.dataInizio = this.convertDateLocal(this.info.dataInizioPeriodo);
        this.dataFine = this.convertDateLocal(this.info.dataFinePeriodo);
        this.dataInizioTemp = this.convertDateToISO(this.info.dataInizioPeriodo);
        this.dataFineTemp = this.convertDateToISO(this.info.dataFinePeriodo);
        this.dataInizioRules = [true];
        this.dataFineRules = [true];
        this.isAnnullato = this.info.idStatoAccettazione === 7;
    }

    validazioneDataInizio() {
        var valid: boolean = false;
        if (this.dataInizio === "") {
            this.dataInizioRules = [true];
        } else {
            valid = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d\d$/.test(this.dataInizio);
            if (valid) {
                this.dataInizioRules = [true];
            } else {
                this.dataInizioRules = [
                    "Data Inizio non valida. Formato corretto: gg/mm/aaaa"
                ];
            }
        }
    }

    validazioneDataFine() {
        var valid: boolean = false;
        if (this.dataFine === "") {
            this.dataFineRules = [true];
        } else {
            valid = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d\d$/.test(this.dataFine);
            if (valid) {
                this.dataFineRules = [true];
            } else {
                this.dataFineRules = [
                    "Data Fine non valida. Formato corretto: gg/mm/aaaa"
                ];
            }
        }
    }

    validazioneDate() {
        this.validazioneDataInizio();
        this.validazioneDataFine();

        if (this.dataInizioRules[0] === true && this.dataFineRules[0] === true) {
            const partsInizio = this.dataInizio.split('/');
            const partsFine = this.dataFine.split('/');

            const dateInizio = new Date(
                parseInt(partsInizio[2], 10),
                parseInt(partsInizio[1], 10) - 1,
                parseInt(partsInizio[0], 10)
            );
            const dateFine = new Date(
                parseInt(partsFine[2], 10),
                parseInt(partsFine[1], 10) - 1,
                parseInt(partsFine[0], 10)
            );

            if (dateFine < dateInizio) {
                this.dataFineRules = [
                    "La Data Fine deve essere successiva o uguale alla Data Inizio"
                ];
            }
        }
    }

    @Watch("dataInizioTemp")
    onDataInizioTempChange() {
        this.dataInizioFilter();
    }

    @Watch("dataFineTemp")
    onDataFineTempChange() {
        this.dataFineFilter();
    }

    dataInizioFilter() {
        if (this.dataInizioTemp !== null && this.dataInizioTemp !== '') {
            const date = new Date(this.dataInizioTemp);
            this.dataInizio = date.toLocaleDateString('it-IT', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } else {
            this.dataInizio = "";
        }
        this.dataInizioMenu = false;
        this.validazioneDataInizio();
    }

    dataFineFilter() {
        if (this.dataFineTemp !== null && this.dataFineTemp !== '') {
            const date = new Date(this.dataFineTemp);
            this.dataFine = date.toLocaleDateString('it-IT', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } else {
            this.dataFine = "";
        }
        this.dataFineMenu = false;
        this.validazioneDataFine();
    }

    close() {
        this.dataInizioMenu = false;
        this.dataFineMenu = false;
        this.dataInizio = this.convertDateLocal(this.info.dataInizioPeriodo);
        this.dataFine = this.convertDateLocal(this.info.dataFinePeriodo);
        this.dataInizioTemp = this.convertDateToISO(this.info.dataInizioPeriodo);
        this.dataFineTemp = this.convertDateToISO(this.info.dataFinePeriodo);
        this.dataInizioRules = [true];
        this.dataFineRules = [true];
        this.isAnnullato = this.info.idStatoAccettazione === 7;
        bus.$emit("closeEditDialog");
    }

    async executeTest() {
        this.validazioneDate();
    }

    convertDateToISO(data: any) {
        if (!data) return '';
        const parts = data.split('/');
        const isoDate = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
        return isoDate;
    }

    convertDateLocal(data: any) {
        if (!data) return '';
        const dataTmp = this.convertDateToISO(data);
        const parts = dataTmp.split('-');
        return `${parts[2].padStart(2, '0')}/${parts[1].padStart(2, '0')}/${parts[0]}`;
    }

    save() {
        this.executeTest().then(() => {
            if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
                var payload: any = {
                    idRichiestaTirocinioFormativo: this.info.idRichiesta,
                    dataInizio: this.dataInizioTemp,
                    dataFine: this.dataFineTemp,
                    idStatoAccettazione: this.isAnnullato ? 7 : this.info.idStatoAccettazione
                };
                user.dispatchEditTirFormativo(this["$store"], payload)
                    .then(() => {
                        bus.$emit("loadPreAssegnazioni");
                        bus.$emit(
                            "successfullOperation",
                            "Tirocinio formativo aggiornato con successo."
                        );
                        this.close();
                    })
                    .catch(error => {
                        if (error.response.status === 403) {
                            bus.$emit("errorOperation", error.response.statusText);
                            this["$router"].push("/login");
                        } else {
                            bus.$emit("errorOperation", error.response.statusText);
                        }
                    });
            }
        });
    }
}
